import { CustomFieldType, ModelBasic } from '..';

export interface TranslationKey extends ModelBasic {
  translation_key: string;
  field_type: CustomFieldType;
  translations: TranslationKeyTranslation[];
}

export interface TranslationKeyTranslation extends ModelBasic {
  language: TranslationLanguage;
  alreadyChanged: boolean;
  translation: string;
}
export interface TranslationLanguage extends ModelBasic {
  language: string;
  language_code: string;
  is_default: boolean;
}

export interface TranslationTranslationLanguage {
  language: TranslationLanguage;
  translation_keys: TranslationTranslationLanguageKey[];
  progress: number;
}
export interface TranslationTranslationLanguageKey {
  index?: string;
  translation_key: TranslationKey;
  translation: TranslationKeyTranslation;
}

export interface TranslationKeyValidaton {
  translationKey: string;
  defaultLanguageCodes: string[];
  minLength?: number;
  maxLength?: number;
}
